export default "__VITE_ASSET__BBtrvCHt__"